module.exports = __webpack_public_path__ + "assets/img/btn-view-40fa6afb.png";